const Eloquent = window.Eloquent;

/**
 * Register user with email and password
 * @param {String} email
 * @param {String} password
 * @param {String} code
 * @param {String} firstName
 * @param {String} lastName
 * @returns {Promise}
 */
export function register(email, password, code, firstName, lastName) {
    return Eloquent.Auth.register(email, password, code, firstName, lastName);
}


/**
 * Refresh user login token
 * @returns {Promise}
 */
export function refreshToken() {
    return Eloquent.Auth.refresh();
}



/**
 * Login user with email and password
 * @param {String} email
 * @param {String} password
 * @returns {Promise}
 */
export function login(email, password) {
    return Eloquent.Auth.login(email, password);
}


/**
 * Logout user
 * @returns {Promise}
 */
export function logout() {
    return Eloquent.Auth.logout();
}


/**
 * Login user with social account
 * @param {String} token - provided by Facebook/Google
 * @param {String} provider - only "facebook" supported
 * @returns {Promise}
 */
export function socialLogin(token, provider) {
    return Eloquent.Auth.socialLogin(provider, token);
}


/**
 * Check if email is registered in the system
 * @param {String} email
 * @returns {Promise}
 */
export function checkEmail(email) {
    return Eloquent.Auth.checkEmail(email);
}


/**
 * Check if the user is logged in
 * @returns {Promise}
 */
export function checkAuthStatus() {
    return Eloquent.Auth.checkLoginStatus();
}

/**
 * send recovery link to user's email
 * @param {String} email
 * @returns {Promise}
 */
export function sendRecoverLink(email) {
    return Eloquent.Auth.sendResetPasswordEmail(email);
}

/**
 * check validity of recover token
 * @param {String} token
 * @returns {Promise}
 */
export function checkRecoverToken(token) {
    return Eloquent.Auth.checkResetTokenStatus(token);
}

/**
 * Reset password of a user
 * @param {String} token
 * @param {String} password
 * @returns {Promise}
 */
export function resetPassword(token, password) {
    return Eloquent.Auth.resetPassword(token, password);
}



// WEBPACK FOOTER //
// ./src/api/auth.js